import Samples from "../../pages/Samples";
import { InternalAndGuestUserRoles, Role } from "../../constants/roles";
import { ReactComponent as SamplesIcon } from "../../assets/samplesicon.svg";
import NewSample from "../../pages/Samples/NewSamples";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/samples";
const accessRoles: Role[] = InternalAndGuestUserRoles;

export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: Samples,
  allowedRoles: accessRoles,
  label: "Samples",
  icon: () => <SamplesIcon />,
  isCustomIcon: true,
  hasDivider: false,
};

export const samplesRoutes: { [key: string]: RouteConfig } = {
  samples: baseRoute,
  newSample: {
    path: "/newSample",
    component: NewSample,
    allowedRoles: accessRoles,
  },
};
